/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Avatar,
  Button,
  Container,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import { useSnackbar } from 'notistack';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { DataGrid } from '@mui/x-data-grid';
import { fNumber } from 'utils/formatNumber';
import { LoadingButton } from '@mui/lab';
import CustomGridToolbar from 'components/CustomGridToolbar';
import ProfileDialog from 'sections/@dashboard/user/ProfileDialog';



export default function UserList() {
  // const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [modal, setModal] = useState({open:false, user:{}});
  const [sort, setSort] = useState({field:'id', order:'desc',page_size:100,page:0});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  // const [query,setQuery] = useState({});
  const [dailog,setDailog] = useState({open:false,query:"",});
  const [profileDialog,setProfileDialog] = useState({open:false,user:"",});
  const [search,setSearch] = useState({open:false,query:"", list:[]});
  const { enqueueSnackbar } = useSnackbar();


  useEffect(() => {
    getInitData();
  }, []);

  // const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));

  return (
    <Page title="Users wallet balance">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="User's wallet balance"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'User', href: PATH_DASHBOARD.user.root },
            { name: 'Wallet' },
          ]}
        />

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        <Card>
            <Box sx={{display:"flex", alignContent:"right ", justifyContent:"end", width:"100%", padding:2}}>
              <FormControl sx={{ml:2,width:180}}>
                <InputLabel id="demo-simple-select-label2">Sort balance</InputLabel>
                <Select
                  labelId="demo-simple-select-label2"
                  label="Sort balance"
                  value={sort.order}
                  onChange={(e)=> setSort({...sort,order:e.target.value})}
                >
                  {[
                    {v:'asc',n:"Ascending"},
                    {v:'desc',n:"Descending"},
                    ].map((opt,i) => (
                  <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LoadingButton loading={state.loading} onClick={()=> getInitData()}
                sx={{ml:2}} variant='outlined' color="secondary">
                  Apply changes
              </LoadingButton> 
              
            </Box>

          <Box sx={{ height: 850, width: '100%' }}>
            <DataGrid
              rows={search.open ? search.list : data.data}
              columns={[
                // {
                //   field: 'name',
                //   headerName: 'Name',
                //   width: 220,
                //   editable: false,
                //   renderCell: (params) => (
                //     <>
                //       <Avatar alt={params.value} src={params.row.image_url} sx={{ mr: 2 }} />
                //       <Typography variant="subtitle2">
                //         {params.row.first_name} {params.row.last_name}
                //       </Typography>
                //     </>
                //   ),
                //   valueGetter: (params) => `${params.row.first_name} ${params.row.last_name}`
                // },
                {
                  field: 'display_name',
                  headerName: 'Name',
                  width: 220,
                  editable: false,
                  renderCell: (params) => (
                    < >
                      <IconButton color="primary" onClick={()=> setProfileDialog({open:true,user:params.row})}>
                        <Iconify icon={'ph:user-thin'} size="small" sx={{width:25,height:25}} />
                      </IconButton>
                      <Typography variant="subtitle2" sx={{cursor:"pointer"}} noWrap>
                        {params.value || `${params.row.first_name} ${params.row.last_name}`}
                      </Typography>
                    </>
                  ),
                  valueGetter: (params) => params.value
                },
              
                {
                  field: 'balance',
                  headerName: 'balance Amount',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `${params.row.currency}${fNumber(params.value)}`,
                },
                {
                  field: 'ledger_balance',
                  headerName: 'Ledger balance',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `${params.row.currency}${fNumber(params.value)}`,
                },
                {
                  field: 'transaction_id',
                  headerName: 'Lastest transaction I.D',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'updated_at',
                  headerName: 'Updated at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDate(params.value),
                },
                
              ]}
              
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
              disableSelectionOnClick

              paginationMode="server"
              rowCount={data.total_size}
              page={data.current_page - 1}
              rowsPerPage={data.data.length}
              onPageChange={(newPage)=> {
                setSort({...sort, page:newPage + 1});
                getInitData(newPage + 1);
              }}
              pageSize={data.page_size}
              onPageSizeChange={(newPage) => setSort({...sort, page_size:newPage})}
              rowsPerPageOptions={[]}
              
            />
          </Box>
        </Card>
      </Container>


      {profileDialog.open &&  <ProfileDialog
        user={profileDialog.user}
        refresh
        handleClose={()=>{
          setProfileDialog({open:false});
        }}
         />}

    </Page>
  );

  async function getInitData(page = null) {
    
    // if(data.data.length > 0){
    //   setData({...data,data:[]});
    // }
    setState({...state,loading:true,loadComplete:false,error:null});

    try {
      const str = `?sort_order=${sort.order}&page=${page || sort.page}&page_size=${sort.page_size}`;

      const response = await axios.get(CRUD.user.wallet+str);

      if (isMountedRef.current) {
        setData(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };

}
